/* ==========================================================================
  critical.js
========================================================================== */

/**
 * Before lazyloaded image is loaded
 */
document.addEventListener('lazybeforeunveil', function(e){

  // current <img> element
  var el = e.target;

  /**
   * Hide possible pre-load image when current image is loaded:
   * <img class="lazyload"> <-- actual image
   * <img class="lazyload-preload"> <-- preload image
   */
  el.addEventListener('load', function() {

    //console.log(this);

    // when loaded, animate blurry version
    var sibling = el.nextSibling;
    if (sibling && sibling !== el && sibling !== null && sibling !== undefined && sibling.nodeType === 1) {
      if (typeof sibling.classList.contains !== "undefined") {
        if (sibling.classList.contains('lazyload-preload')) {
          sibling.classList.add('lazyload-preload--ready');
        }
      } else {
        // legacy browser, skip logic
        sibling.classList.add('lazyload-preload--ready');
      }

    }

  });

});

/**
 * Setup full-size hero height
 */
var desktop_min_width = 1320;
var old_sreen_w = 0;
function sb_set_full_size_hero_height() {
  var header = document.getElementById('masthead');
  var hero = document.querySelectorAll('.hero--size-full');
  var screen_width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  var screen_height = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
  for (i = 0; i < hero.length; i++) {
    if (hero[i] && header && screen_width !== old_sreen_w) {

      var offset = header.offsetHeight;
      if (screen_width > desktop_min_width) {
        offset += 80; // leave room for booking
      }

      var new_height = screen_height - offset;

      // height should be max 16:9 so let's take care of it
      var calculated_height = 9 / 16 * screen_width;

      // revert to calculated 16:9
      if (new_height > calculated_height) {
        new_height = calculated_height;
      }

      hero[i].style.minHeight = new_height + 'px';
    }
  }
  old_sreen_w = screen_width;
}
sb_set_full_size_hero_height();
document.addEventListener('DOMContentLoaded', function(){
  sb_set_full_size_hero_height();
}, false);
window.addEventListener('resize', function(event){
  sb_set_full_size_hero_height();
});
